import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './index.css';

const rootElem = document.getElementById('root');
if (rootElem) {
  createRoot(rootElem).render(<App />);
  rootElem.classList.remove('tw:min-h-screen');
}
